import React from "react";
import vhCheck from "vh-check";
import TalentApplication from "../../TalentApplication";
import stateChart from "../stateChart";
import StateMachine from "../../utils/StateMachine";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import asyncComponent from "../../../utils/asyncComponent.js";
import WebLogin from "../../Home/Login/web-login";
import Shop from "../../Account/Shop";
import MemberShipMissing from "../../Account/MembershipMissing";
import Account from "../../Account";
import Settings from "../../Account/Settings";
import Notifications from "../../Account/Notifications";
import Club from "../../Account/Club";
import EditProfile from "../../Account/EditProfile/edit-profile";
import ContactInfo from "../../Account/EditProfile/ContactInfo/contact-info";
import Instructions from "../../TalentApplication/Instructions";
import Skills from "../../Account/EditProfile/Skills/skills";
import InstagramMedia from "../../Account/EditProfile/Instagram/media";
import InstagramConnect from "../../Account/EditProfile/Instagram/connect";
import InstagramSelectPhotos from "../../Account/EditProfile/Instagram/select-photos";
import AboutUsClub from "../../AboutUs/AboutUsClub";
import SessionTransfer from "../../Account/SessionTransfer";
import TestGifting from "../../Account/TestGifting";

// Sets css variable --vh-offset
vhCheck();

const Contact = asyncComponent(() =>
  import("../../Register/ContactUs")
);
const TermsOfUse = asyncComponent(() =>
  import("../../LegalAgreements/TermsOfUse")
);


const CookiePolicy = asyncComponent(() =>
  import("../../LegalAgreements/CookiePolicy")
);

const PrivacyPolicy = asyncComponent(() =>
  import("../../LegalAgreements/PrivacyPolicy")
);

const Support = asyncComponent(() =>
  import("../../Support")
);

const Admin = asyncComponent(() => import("../../Admin"));

export default function ClubRoutes() {
    return (
        <Router>
            <StateMachine machine={stateChart}>
                <Switch>
                    <Route exact path="/aboutus" component={AboutUsClub} />
                    <Route exact path="/session-transfer" component={SessionTransfer} />
                    <Route exact path="/test_gifting" component={TestGifting} />
                    <Route exact path="/memberships" component={Instructions} />
                    <Route exact path="/shop" component={Shop} />
                    <Route exact path="/membership-missing" component={MemberShipMissing} />
                    <Route exact path="/club" component={Club} />
                    <Route exact path="/account" component={Account} />
                    <Route exact path="/settings" component={Settings} />
                    <Route exact path="/notifications" component={Notifications} />
                    <Route exact path="/account/edit-profile" component={EditProfile} />
                    <Route exact path="/account/contact-info" component={ContactInfo} />
                    <Route exact path="/account/skills" component={Skills} />
                    <Route exact path="/login" component={WebLogin} />
                    <Route exact path="/account/instagram" component={InstagramMedia} />
                    <Route exact path="/account/instagram/connect" component={InstagramConnect} />
                    <Route exact path="/account/instagram/select-photos" component={InstagramSelectPhotos} />
                    <Route path="/apply" component={TalentApplication} />
                    {/*Temporary route to clear localStorage and redirect to signup*/}
                    <Route exact path="/reset" render={() => {
                        localStorage.clear();
                        return <Redirect to="/apply" />;
                    }} />
                    <Route path="/admin" component={Admin} />
                    <Route path="/terms-of-use" component={TermsOfUse} />
                    <Route path="/contact-us" component={Contact} />
                    <Route path="/cookie-policy" component={CookiePolicy} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/support" component={Support} />
                    <Redirect from="/terms-and-conditions" to="/terms-of-use" />
                    <Redirect from="/privacy-notice" to="/privacy-policy" />
                    <Redirect from="/cookie-statement" to="/cookie-policy" />
                    <Redirect to="/aboutus" />
                </Switch>
            </StateMachine>
        </Router>
    );
}

